import axios from 'axios';
import * as actionTypes from '../constants/cartConstants';

// const URL='http://localhost:8000';
const URL='https://e-commerce-website-backend-smul.onrender.com';
export const addToCart=(id,quantity)=>async(dispatch)=>{
    try{
        console.log('id axios call');
        console.log(id);
        const {data}=await axios.get(`${URL}/product/${id}`);
        dispatch({type:actionTypes.ADD_TO_CART_SUCCESS, payload:{...data,quantity}});
    }
    catch(e){
        dispatch({type:actionTypes.ADD_TO_CART_ERROR, payload:e.message});
    }
}

export const removeFromCart=(id)=>(dispatch)=>{
    dispatch({type:actionTypes.REMOVE_FROM_CART,payload:id});
}